<template>
  <b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
        <b-col cols="3">
          <Menu></Menu>
        </b-col>
        <b-col cols="9">
          <b-row class="border">
            <b-col cols="12">
              <b-row>
                <b-col cols="12" class="head">
                  <h4>:: Modelos</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="breadcrumb">
                  <b-link :to="{ name: 'BrandListModels' }">Modelos por marcas</b-link> &raquo; Lista de Modelos de {{ this.$route.params.slug.toUpperCase() }}:
                  <b-link :to="{ name: 'CreateModel' }" class="text-right" style="float: right;">Agregar Modelo para {{ this.$route.params.slug.toUpperCase() }}</b-link>
                </b-col>
              </b-row>
              <div class="mt-2"></div>
              <b-table striped hover :items="models" :fields="fields">
                <template slot="actions" slot-scope="row">
                  <b-btn size="sm" @click.stop="details(row.item)">Ver detalle</b-btn>
                  <b-btn size="sm" @click.stop="versiones(row.item)">Ver versiones</b-btn>
                </template>
              </b-table>
              <ul v-if="errors && errors.length">
                <li v-for="(error, index) in errors" :key="index">
                  <b-alert show>{{error.message}}</b-alert>
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import Header from './Header'
import Menu from './Menu'
export default {
  name: "ModelsListByBrand",
  components:{
    Header,
    Menu
  },
  data() {
    return {
      fields: {
        name: { label: "Nombre del Modelo", sortable: true, class: "text-left" },
        brand: { label: "Marca", sortable: false, class: "text-center" },
        created_at: {
          label: "Fecha de Ingreso",
          sortable: true,
          class: "text-center"
        },
        actions: { label: "", class: "text-center" }
      },
      models: []
    };
  },
  created() {
    if(localStorage.getItem('role')=="Administrador"){
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios
      .get(`/models-brands/` + this.$route.params.slug)
      .then(response => {
        this.models = response.data;
      })
      .catch(e => {
        this.errors.push(e);
      })
    }else{
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    details (model) {
      this.$router.push({
        name: 'ShowModel',
        params: { id: model._id, slug: this.$route.params.slug, brand: model.brand }
      })
    },
    versiones (model) {
      this.$router.push({
        name: 'VersionesByModel',
        params: {slug: this.$route.params.slug, brand: model.brand, model:model.name, model_id: model._id}
      })
      console.log(model);
    },
    logout () {
      localStorage.removeItem('jwtToken')
      this.$router.push({
        name: 'Login'
      })
    }
  }
};
</script>

<style>
.jumbotron {
  padding: 2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/ModelsListByBrand.vue